<style lang="less" scoped src="@/assets/less/manage-space/base.less"></style>

<template>
    <div>
        <SettingsCard
            id="SettingsCardSignUpStrategy"
            :title="$t('labels.signupstrategy')"
            :subtitle="$t('messages.authSignUpStrategy')"
            to="/admin/setup/signup-strategy"
            :isNew="true"
        ></SettingsCard>
        <SettingsCard
            id="SettingsCardAuthenticationIdentityProviders"
            :title="$t('labels.identityproviders')"
            :subtitle="$t('messages.authIdentityProviders')"
            to="/admin/settings/authentications/providers"
        />
    </div>
</template>

<script>
import SettingsCard from '@/components/admin/SettingsCard.vue';

export default {
    name: 'AuthenticationsSettings',
    components: { SettingsCard },
    data() {
        return {};
    },
};
</script>
